<div class="users-table-container">
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div style="padding-top: 4px"></div>
  }

  <mat-card appearance="outlined">
    <div class="table-container">
      <table
        #table
        mat-table
        [dataSource]="dataSource()"
        matSort
        matSortStart="desc"
        (matSortChange)="onSortChange($event)"
        class="mat-elevation-z8 responsive-table"
      >
        <!-- Coluna Nome -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
          <td mat-cell *matCellDef="let user">{{ user.name }}</td>
        </ng-container>

        <!-- Coluna E-mail -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>E-mail</th>
          <td mat-cell *matCellDef="let user">{{ user.email }}</td>
        </ng-container>

        <!-- Coluna Perfil -->
        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Perfil</th>
          <td mat-cell *matCellDef="let user">
            <mat-chip [ngClass]="getRoleClass(user.role)">
              {{ user.roleLabel }}
            </mat-chip>
          </td>
        </ng-container>

        <!-- Coluna Empresa -->
        <ng-container matColumnDef="organizationName">
          <th mat-header-cell *matHeaderCellDef>Empresa</th>
          <td mat-cell *matCellDef="let user">
            {{ user.organizationName || "—" }}
          </td>
        </ng-container>

        <!-- Coluna Último Acesso -->
        <ng-container matColumnDef="lastAccess">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Último Acesso
          </th>
          <td mat-cell *matCellDef="let user">
            {{
              user.lastAccess
                ? (user.lastAccess | date: "dd/MM/yyyy HH:mm")
                : "Aguardando acesso"
            }}
          </td>
        </ng-container>

        <!-- Coluna Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let user">
            <mat-chip [ngClass]="getStatusClass(user.status)">
              {{ getStatusLabel(user.status) }}
            </mat-chip>
          </td>
        </ng-container>

        <!-- Coluna Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Ações</th>
          <td mat-cell *matCellDef="let user">
            <button
              mat-icon-button
              [matMenuTriggerFor]="actionsMenu"
              matTooltip="Ações"
            >
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #actionsMenu="matMenu">
              @for (action of actions(); track action.label) {
                @if (shouldShowAction(action, user)) {
                  <button mat-menu-item (click)="action.action(user)">
                    <mat-icon>{{ action.icon }}</mat-icon>
                    <span>{{ action.label }}</span>
                  </button>
                }
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- No data row -->
        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell"
            [attr.colspan]="displayedColumns.length"
            style="text-align: center"
          >
            Nenhum usuário encontrado
          </td>
        </tr>
      </table>
    </div>
  </mat-card>

  <!-- Paginação -->
  <mat-paginator
    [length]="length()"
    (page)="onPageChange($event)"
    showFirstLastButtons
    aria-label="Selecione a página de usuários"
    class="paginator"
  >
  </mat-paginator>
</div>
